
import { Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Index from "@/pages/Index";
import Product from "@/pages/Product";
import Cart from "@/pages/Cart";
import Account from "@/pages/Account";
import AccountCreated from "@/pages/AccountCreated";
import OrderConfirmation from "@/pages/OrderConfirmation";
import AdminOrders from "@/pages/AdminOrders";
import AdminProducts from "@/pages/AdminProducts";
import AdminBlogs from "@/pages/AdminBlogs";
import AdminProjects from "@/pages/AdminProjects";
import AdminEvents from "@/pages/AdminEvents";
import AdminContactMessages from "@/pages/AdminContactMessages";
import OrderHistory from "@/pages/OrderHistory";
import NotFound from "@/pages/NotFound";
import CGV from "@/pages/CGV";
import Confidentialite from "@/pages/Confidentialite";
import ResetPassword from "@/pages/ResetPassword";
import UpdatePassword from "@/pages/UpdatePassword";
import APropos from "@/pages/APropos";
import Services from "@/pages/Services";
import ServiceAssistance from "@/pages/ServiceAssistance";
import ServiceInspection from "@/pages/ServiceInspection";
import ServiceProAction from "@/pages/ServiceProAction";
import ServiceUrgence from "@/pages/ServiceUrgence";
import Contact from "@/pages/Contact";
import Projets from "@/pages/Projets";
import ProjetDetail from "@/pages/ProjetDetail";
import Blogue from "@/pages/Blogue";
import BlogueArticle from "@/pages/BlogueArticle";
import ProductLely from "@/pages/ProductLely";
import ProductBoumatic from "@/pages/ProductBoumatic";
import ProductMueller from "@/pages/ProductMueller";
import ProductLiberchem from "@/pages/ProductLiberchem";
import AdminRoute from "@/components/auth/AdminRoute";
import AdminEmployees from "@/pages/AdminEmployees";
import AdminCreateClient from "@/pages/AdminCreateClient";
import AdminClients from "@/pages/AdminClients";
import ProfileGuard from "@/components/auth/ProfileGuard";

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<ProfileGuard><Home /></ProfileGuard>} />
      <Route path="/home" element={<ProfileGuard><Home /></ProfileGuard>} />
      <Route path="/boutique" element={<ProfileGuard><Index /></ProfileGuard>} />
      <Route path="/a-propos" element={<ProfileGuard><APropos /></ProfileGuard>} />
      <Route path="/services" element={<ProfileGuard><Services /></ProfileGuard>} />
      <Route path="/services/assistance" element={<ProfileGuard><ServiceAssistance /></ProfileGuard>} />
      <Route path="/services/inspection" element={<ProfileGuard><ServiceInspection /></ProfileGuard>} />
      <Route path="/services/pro-action" element={<ProfileGuard><ServiceProAction /></ProfileGuard>} />
      <Route path="/services/urgence" element={<ProfileGuard><ServiceUrgence /></ProfileGuard>} />
      <Route path="/contact" element={<ProfileGuard><Contact /></ProfileGuard>} />
      <Route path="/projets" element={<ProfileGuard><Projets /></ProfileGuard>} />
      <Route path="/projets/:slug" element={<ProfileGuard><ProjetDetail /></ProfileGuard>} />
      <Route path="/blogue" element={<ProfileGuard><Blogue /></ProfileGuard>} />
      <Route path="/blogue/:slug" element={<ProfileGuard><BlogueArticle /></ProfileGuard>} />
      <Route path="/produits/lely" element={<ProfileGuard><ProductLely /></ProfileGuard>} />
      <Route path="/produits/boumatic" element={<ProfileGuard><ProductBoumatic /></ProfileGuard>} />
      <Route path="/produits/mueller" element={<ProfileGuard><ProductMueller /></ProfileGuard>} />
      <Route path="/produits/liberchem" element={<ProfileGuard><ProductLiberchem /></ProfileGuard>} />
      {/* Support both slug and ID-based URLs for backward compatibility */}
      <Route path="/product/:id" element={<ProfileGuard><Product /></ProfileGuard>} />
      <Route path="/products/:slug" element={<ProfileGuard><Product /></ProfileGuard>} />
      <Route path="/cart" element={<ProfileGuard><Cart /></ProfileGuard>} />
      <Route path="/account" element={<Account />} />
      <Route path="/account/created" element={<AccountCreated />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/account/update-password" element={<UpdatePassword />} />
      <Route path="/order-confirmation" element={<ProfileGuard><OrderConfirmation /></ProfileGuard>} />
      <Route path="/order-history" element={<ProfileGuard><OrderHistory /></ProfileGuard>} />
      <Route path="/admin/orders" element={<ProfileGuard><AdminRoute requireOrderAccess><AdminOrders /></AdminRoute></ProfileGuard>} />
      <Route path="/admin/products" element={<ProfileGuard><AdminRoute requireProductAccess><AdminProducts /></AdminRoute></ProfileGuard>} />
      <Route path="/admin/employees" element={<ProfileGuard><AdminRoute><AdminEmployees /></AdminRoute></ProfileGuard>} />
      <Route path="/admin/create-client" element={<ProfileGuard><AdminRoute><AdminCreateClient /></AdminRoute></ProfileGuard>} />
      <Route path="/admin/clients" element={<ProfileGuard><AdminRoute><AdminClients /></AdminRoute></ProfileGuard>} />
      <Route path="/admin/blogs" element={<ProfileGuard><AdminRoute requireContentAccess><AdminBlogs /></AdminRoute></ProfileGuard>} />
      <Route path="/admin/projects" element={<ProfileGuard><AdminRoute requireContentAccess><AdminProjects /></AdminRoute></ProfileGuard>} />
      <Route path="/admin/events" element={<ProfileGuard><AdminRoute requireContentAccess><AdminEvents /></AdminRoute></ProfileGuard>} />
      <Route path="/admin/contact-messages" element={<ProfileGuard><AdminRoute><AdminContactMessages /></AdminRoute></ProfileGuard>} />
      <Route path="/cgv" element={<ProfileGuard><CGV /></ProfileGuard>} />
      <Route path="/confidentialite" element={<ProfileGuard><Confidentialite /></ProfileGuard>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Router;
